import styles from './Tour.module.css'

interface WelcomeCardProps {
  onStart: () => void
  onDefer: () => void   // "Take 30 seconds first" — defers next show by 30s
}

export function WelcomeCard({ onStart, onDefer }: WelcomeCardProps) {
  return (
    <div className={styles.welcomeWrap}>
      <div className={styles.welcomeDim} onClick={onDefer} />
      <div className={styles.welcomeCard} role="dialog" aria-modal="true" aria-label="Welcome to tenwords">
        <div className={styles.welcomeEyebrow}>Welcome</div>
        <h2 className={styles.welcomeTitle}>You&apos;re in. Take a look around.</h2>
        <p className={styles.welcomeBody}>
          tenwords is a discovery tool for vinyl, built around your taste. Over the
          next few minutes, a short tour walks through how the catalogue works and
          how to connect your Discogs account so the app knows you.
        </p>
        <p className={styles.welcomeBody}>
          The tour is broken into five short chapters — pace yourself, the catalogue
          stays interactive the whole time, and the pill in the top-right always
          remembers where you left off.
        </p>
        <div className={styles.welcomeActions}>
          <button className={styles.secondaryBtn} onClick={onDefer}>
            Take 30 seconds first
          </button>
          <button className={styles.primaryBtn} onClick={onStart}>
            <span className={styles.primaryBtnLabel}>
              Start the tour
              <i className="bi bi-arrow-right" />
            </span>
          </button>
        </div>
      </div>
    </div>
  )
}
